import { CButton, CSpinner } from '@coreui/react'

export function LoadingState({ label = 'Loading current records…' }: { label?: string }) {
  return (
    <div className="async-state">
      <CSpinner color="primary" />
      <strong>{label}</strong>
      <span>Please wait a moment.</span>
    </div>
  )
}
export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <div className="async-state async-state--error">
      <strong>We could not load this view.</strong>
      <span>{message}</span>
      {retry && (
        <CButton color="primary" onClick={retry}>
          Try again
        </CButton>
      )}
    </div>
  )
}
export function EmptyState({ title, description }: { title: string; description: string }) {
  return (
    <div className="empty-state">
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
  )
}
